<div class="content">
   <h3>Tickets Export</h3>
   <mat-card class="mt-4 mb-4">
      <mat-card-content>
         <div class="row">
            <div class="col">
               <h3 class="mt-2">Filters</h3>
            </div>

            <div class="col-auto">
               <button mat-raised-button color="accent" class="me-2" (click)="downloadAll()" [disabled]="loading">
                  @if (loading) {
                     <mat-spinner [diameter]="20" color="warn" class="me-2"></mat-spinner>
                     Exporting...
                  } @else {
                     <mat-icon class="me-2">download</mat-icon>
                     Export
                  }
               </button>

               <button
                  class="float-right ml-1"
                  (click)="clearFilter()"
                  [disabled]="emptyFilters"
                  mat-raised-button
                  color="accent"
               >
                  <mat-icon>clear</mat-icon>
                  Clear Filters
               </button>
            </div>
         </div>

         <form [formGroup]="searchForm" class="row form-fields-slim">
            <div class="col-3">
               <app-input-field formControlName="search" label="Search"></app-input-field>
            </div>

            <div class="col-3">
               <app-select-entity-field
                  formControlName="ticketTypeId"
                  [type]="FieldEntityType.package"
                  [multiple]="false"
                  [withSearch]="true"
               ></app-select-entity-field>
            </div>

            <div class="col-3">
               <app-select-field
                  formControlName="ticketStatus"
                  label="Filter by ticket status"
                  [options]="ticketStatus"
               ></app-select-field>
            </div>

            <div class="col-3">
               <app-date-picker-field formControlName="fromDate" label="From"></app-date-picker-field>
            </div>

            <div class="col-3">
               <app-date-picker-field formControlName="toDate" label="To"></app-date-picker-field>
            </div>

            <div class="col-3">
               <app-select-event-field formControlName="eventsIds" [multiple]="true"></app-select-event-field>
            </div>

            <div class="col-3">
               <app-select-field
                  formControlName="paymentDepositOption"
                  label="Filter by deposit payment"
                  [options]="paymentDepositOptions"
               ></app-select-field>
            </div>

            <div class="col-3">
               <app-select-field
                  formControlName="paymentOption"
                  label="Filter by payment"
                  [options]="paymentOptions"
               ></app-select-field>
            </div>

            <div class="col-3">
               <app-select-entity-field
                  formControlName="eventCategoryId"
                  [type]="FieldEntityType.category"
               ></app-select-entity-field>
            </div>
         </form>
      </mat-card-content>
   </mat-card>

   <section class="mat-elevation-z8 mt-3">
      <app-datatable key="tickets-export" [columns]="columns" [dataSource]="dataSource"> </app-datatable>
   </section>
</div>
